import PropTypes from 'prop-types';
import React from 'react';
import { fetchCompanyAds } from '../../CompanyAds/companyAdsFunctions';
import InlineAd from '../../CompanyAds/InlineAd/InlineAd';
import { TopicShape } from '../../Includes/Shapes/Topic';
import { stripAdPlaceholderText } from '../../../utilities/helperFunctions';
import './EditorialContentSection.scss';

export const WRAPPED_AD = '{{{COMPANY_AD_EMBEDED}}}';
export const STANDALONE_AD = '{{{COMPANY_AD_STANDALONE}}}';

const injectContent = (content) => ({ __html: content });

export default class EditorialContentSection extends React.PureComponent {
    constructor(props) {
        super(props);
        const HAS_WRAPPED_AD = this.props.content.includes(WRAPPED_AD);
        const HAS_STANDALONE_AD = this.props.content.includes(STANDALONE_AD);

        const initialContent = stripAdPlaceholderText(this.props.content);

        this.state = {
            HAS_WRAPPED_AD,
            HAS_STANDALONE_AD,
            content: (
                <div dangerouslySetInnerHTML={injectContent(initialContent)} />
            ),
        };
    }

    static propTypes = {
        /**
         *  the more text section text
         * */
        moreText: PropTypes.string,
        /**
         * current topic
         * */
        topic: TopicShape,
        /**
         * content is paid by company
         * */
        isPaid: PropTypes.bool,
        /**
         * text, article content
         * */
        content: PropTypes.string.isRequired,
    };

    static defaultProps = {
        moreText: 'More Articles in',
        topic: {
            name: 'Test',
            url: '/test',
        },
        isPaid: false,
    };

    componentDidMount() {
        const { HAS_STANDALONE_AD, HAS_WRAPPED_AD } = this.state;

        if (HAS_WRAPPED_AD) this.renderContent(WRAPPED_AD);

        if (HAS_STANDALONE_AD) this.renderContent(STANDALONE_AD);
    }

    renderContent = async (type) => {
        const ad = await this.getCompanyAd(type);
        const splitContent = this.props.content.split(type);
        const content1 = (
            <span dangerouslySetInnerHTML={injectContent(splitContent[0])} />
        );
        const content2 = (
            <span dangerouslySetInnerHTML={injectContent(splitContent[1])} />
        );
        const content = [content1, ad, content2];
        this.setState({ content });
    };

    getCompanyAd = async (type) => {
        const { isPaid } = this.props;

        if (isPaid) return null;

        let styleClass = '';
        if (type === WRAPPED_AD) {
            styleClass = 'wrapped';
        }

        try {
            const res = await fetchCompanyAds();
            return <InlineAd className={styleClass} {...res} />;
        } catch (e) {
            console.error(e);
            throw e;
        }
    };

    render() {
        const { content } = this.state;
        return (
            <div className="component-EditorialContent-EditorialContentSection">
                <div className="editorialContentDisplay fr-element fr-view">
                    {content}
                </div>
            </div>
        );
    }
}
